import Multiclient from "components/Core/Multiclient"

const NewPasswordScreen = (props: any) => {
  return <Multiclient path_override="components/User/NewPassword/NewPasswordForm" />
}

export default NewPasswordScreen
